var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRequirement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8700_38054)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8700_38054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8700_38054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.042 19.1027L19.5 21L18.958 19.1027C18.8179 18.6126 18.5553 18.1663 18.1948 17.8058C17.8344 17.4454 17.3881 17.1828 16.898 17.0427L15 16.5L16.8973 15.958C17.3874 15.8179 17.8337 15.5553 18.1942 15.1948C18.5546 14.8344 18.8172 14.3881 18.9573 13.898L19.5 12L20.042 13.8973C20.1821 14.3874 20.4447 14.8337 20.8052 15.1942C21.1656 15.5546 21.6119 15.8172 22.102 15.9573L24 16.5L22.1027 17.042C21.6126 17.1821 21.1663 17.4447 20.8058 17.8052C20.4454 18.1656 20.1821 18.6126 20.042 19.1027Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8M2 7V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.057 11.714L7.337 9.554C7.356 9.536 7.375 9.536 7.394 9.518C7.413 9.5 7.432 9.5 7.47 9.5H11.65C12.182 9.5 12.6 9.896 12.6 10.4V17.6C12.6 18.104 12.182 18.5 11.65 18.5H5.95C5.418 18.5 5 18.104 5 17.6V17.168C5 17.06 5.076 16.988 5.19 16.988C5.285 16.988 5.38 17.06 5.38 17.168V17.6C5.38 17.906 5.627 18.14 5.95 18.14H11.65C11.954 18.14 12.22 17.906 12.22 17.6V10.4C12.22 10.112 11.954 9.86 11.65 9.86H7.66V11.12C7.66 11.624 7.242 12.02 6.71 12.02H5.38V16.088C5.38 16.178 5.285 16.268 5.19 16.268C5.076 16.268 5 16.178 5 16.088V11.84C5 11.804 5 11.786 5.019 11.768C5.038 11.75 5.038 11.732 5.057 11.714ZM7.28 11.12V10.112L5.646 11.66H6.71C7.014 11.66 7.28 11.426 7.28 11.12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19 16.4492C5.29493 16.4492 5.38 16.5298 5.38 16.6292C5.38 16.7286 5.29493 16.8092 5.19 16.8092C5.08507 16.8092 5 16.7286 5 16.6292C5 16.5298 5.08507 16.4492 5.19 16.4492Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.272 16.1605V17.0605C11.272 17.1685 11.196 17.2405 11.082 17.2405H6.52203C6.40803 17.2405 6.33203 17.1685 6.33203 17.0605V16.1605C6.33203 16.0525 6.40803 15.9805 6.52203 15.9805H11.082C11.196 15.9805 11.272 16.0525 11.272 16.1605ZM6.71203 16.8805H9.94203V16.3405H6.71203V16.8805ZM10.892 16.3405H10.322V16.8805H10.892V16.3405Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7009 14.7194H6.90094C6.78694 14.7194 6.71094 14.6474 6.71094 14.5394C6.71094 14.4314 6.78694 14.3594 6.90094 14.3594H10.7009C10.8149 14.3594 10.8909 14.4314 10.8909 14.5394C10.8909 14.6474 10.8149 14.7194 10.7009 14.7194Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7009 13.2818H6.90094C6.78694 13.2818 6.71094 13.2099 6.71094 13.1019C6.71094 12.9939 6.78694 12.9219 6.90094 12.9219H10.7009C10.8149 12.9219 10.8909 12.9939 10.8909 13.1019C10.8909 13.2099 10.8149 13.2818 10.7009 13.2818Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6994 11.8405H8.79937C8.68537 11.8405 8.60938 11.7685 8.60938 11.6605C8.60938 11.5525 8.68537 11.4805 8.79937 11.4805H10.6994C10.8134 11.4805 10.8894 11.5525 10.8894 11.6605C10.8894 11.7685 10.8134 11.8405 10.6994 11.8405Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8700_38054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRequirement);
export default __webpack_public_path__ + "static/media/new_requirement.49df84d3978c8d33fb117ec08b4622a3.svg";
export { ForwardRef as ReactComponent };